import React from "react";

import PrivacyPolicyLayout from "./PrivacyPolicyLayout";

const PrivacyPolicy = () => {
  return (
    <PrivacyPolicyLayout>
      <h1>PRIVACY POLICY</h1>
      <p>
        Respecting your privacy is critically important to achieving our mission
        of motivating every student. These are our guiding privacy principles:
      </p>
      <ul>
        <li>
          We don’t ask you for personal information unless we truly need it.
        </li>
        <li>
          We don’t keep your personal information longer than is necessary to
          provide our services to you.
        </li>
        <li>
          We don’t share your personal information with anyone except to comply
          with the law, provide our services, or protect our rights.
        </li>
        <li>We don’t rent, sell or exchange your personal information.</li>
        <li>
          We aim to make it as simple as possible for you to control what’s
          visible to the public, seen by search engines, kept private, and
          permanently deleted.
        </li>
      </ul>
      <br />
      <h2>How your personal information is used?</h2>
      <ul>
        <li>
          We use information to contact you. We might use the information you
          provide us to contact you for confirmation of booking on our
          website/app or for other promotional purposes.
        </li>
        <li>
          We use information to respond to your requests or questions. We might
          use your information to answer your queries concerning our products or
          services.
        </li>
        <li>
          We use information to improve our products and services. We might use
          your information to customize your experience on our website. This may
          include displaying certain content based on your preferences and/or
          our website usage.
        </li>
        <li>
          We use information to look at site trends and customer interests. We
          may use your information to make our website, app, and products
          better. We may combine information we get from you with information
          about you we get from third parties.
        </li>
        <li>
          We use information for marketing purposes. From time to time, we might
          send you information about special promotions or offers. We might also
          inform you about new features or products. These might be our own
          offers or products, or third-party offers or products we think you
          might find interesting. Or, for example, if you sign up on our website
          and/or blog we may enroll you in our newsletter.
        </li>
        <li>
          We use information to send you transactional communications. We might
          send you emails or SMS about your account, any bookings you may
          request/undertake or any payments you may make.
        </li>
        <li>
          We use information as otherwise permitted by law, or to comply with
          the law or orders of law enforcement agencies or to enforce our legal
          rights.
        </li>
        <li>
          Your consent. By using the Site you shall be deemed to have expressly
          consented to our use of your information and data as aforementioned.
          Further the Company and our service providers may collect, transfer,
          store and process your information outside of your country of
          residence subject to applicable law. By providing us with your
          information or using the Site, you consent to the transfer and
          processing of your information.
        </li>
      </ul>
      <br />
      <h2>CONSENT</h2>
      <p>How do you get my consent?</p>
      <p>
        When you provide us with personal information to complete a transaction,
        verify your credit card, place an order, arrange for a delivery or
        return a purchase, we imply that you consent to our collecting it and
        using it for that specific reason only. If we ask for your personal
        information for a secondary reason, like marketing, we will either ask
        you directly for your expressed consent or provide you with an
        opportunity to say no.
      </p>
      <p>How do I withdraw my consent?</p>
      <p>
        If after you opt-in, you change your mind, you may withdraw your consent
        for us to contact you, for the continued collection, use, or disclosure
        of your information, at any time, by contacting us at{" "}
        <a href="mailto:contact@maidaan.app">contact@maidaan.app</a>.
      </p>
      <br />
      <h2>SECURITY</h2>
      <p>
        To protect your personal information, we take reasonable precautions and
        follow industry best practices to make sure it is not inappropriately
        lost, misused, accessed, disclosed, altered or destroyed.
      </p>
      <br />
      <h2>THIRD-PARTY SERVICES</h2>
      <p>
        In general, the third-party providers used by us will only collect, use
        and disclose your information to the extent necessary to allow them to
        perform the services they provide to us. However, certain third-party
        service providers, such as payment gateways and other payment
        transaction processors, have their own privacy policies in respect to
        the information we are required to provide to them for your
        purchase-related transactions. For these providers, we recommend that
        you read their privacy policies so you can understand the manner in
        which your personal information will be handled by these providers. In
        particular, remember that certain providers may be located in or have
        facilities that are located a different jurisdiction than either you or
        us. So if you elect to proceed with a transaction that involves the
        services of a third-party service provider, then your information may
        become subject to the laws of the jurisdiction(s) in which that service
        provider or its facilities are located. Once you leave our store’s
        website or are redirected to a third-party website or application, you
        are no longer governed by this Privacy Policy or our website’s Terms of
        Service.
      </p>
      <br />
      <h2>COOKIES</h2>
      <p>
        We use cookies to maintain session of your user. It is not used to
        personally identify you on other websites.
      </p>
      <br />
      <h2>CHANGES TO THIS PRIVACY POLICY</h2>
      <p>
        We reserve the right to modify this privacy policy at any time, so
        please review it frequently. Changes and clarifications will take effect
        immediately upon their posting on the website. If we make material
        changes to this policy, we will notify you here that it has been
        updated, so that you are aware of what information we collect, how we
        use it, and under what circumstances, if any, we use and/or disclose it.
        If our store is acquired or merged with another company, your
        information may be transferred to the new owners so that we may continue
        to sell products to you.
      </p>
      <br />
      <h2>Grievance Redressal Officer</h2>
      <p>
        In the event that you have a grievance regarding our privacy policy or
        data usage practices, you may reach out to our Grievance Redressal
        Officer at the details below:
      </p>
      <p>Grievance Redressal Officer: Mr. Shashank Awasthi</p>
      <p>
        Email: <a href="mailto:contact@maidaan.app">contact@maidaan.app</a>
      </p>
    </PrivacyPolicyLayout>
  );
}

export default PrivacyPolicy;
